// extracted by mini-css-extract-plugin
export default {"button":"Results-module__button__TZpjF"};